export default __webpack_public_path__ + "static/media/comment.ef88be84.svg";